import { createApp } from 'vue'
import App from './App.vue'
import './tailwind.css'
import VueAxios from 'vue-axios'
import axios from 'axios'
import router from './router/index'
import i18n from './locale/i18n'
import store from "./store/index"
import emitter from './emitter/useEmiter';
import Echo from "laravel-echo";
import moment from 'moment';
import Vue3Marquee from 'vue3-marquee'
import pusherJs from 'pusher-js'
import geolocalisation from './js/geolocalisation'
import crypto from './js/Crypt'
import decrypto from './js/Decrypt'
import whatsappMessageRememderAcheteur from './js/whatsappMessageRememderAcheteur'
import whatsappMessageReminderVendeur from './js/whatsappMessageReminderVendeur'
import pwaForceUpdate from './js/pwaForceUpdate'
import { registerPwaInstallation } from './js/pwaInstallation'
import registerSmartImageLoading from './js/smartImageLoading'
import installIdempotency from './js/idempotency'
import { articleImage, articleImages } from './js/articleImages'
import { avatarImage, bannerImage } from './js/profileImages'

window.moment = moment
window.emitter = emitter
window.Pusher = pusherJs

// Créer une seule instance de l'application
const app = createApp(App)

installIdempotency(axios)

// Définir les propriétés globales
app.config.globalProperties.$moment = moment
app.config.globalProperties.$mitt = emitter
app.config.globalProperties.$crypto = crypto
app.config.globalProperties.$decrypto = decrypto
app.config.globalProperties.$geo = geolocalisation
app.config.globalProperties.$whatsappMessageRememderAcheteur = whatsappMessageRememderAcheteur
app.config.globalProperties.$whatsappMessageReminderVendeur = whatsappMessageReminderVendeur
app.config.globalProperties.$articleImage = articleImage
app.config.globalProperties.$articleImages = articleImages
app.config.globalProperties.$avatarImage = avatarImage
app.config.globalProperties.$bannerImage = bannerImage
app.config.globalProperties.$markImageLoaded = (image) => {
    if (!image) return
    store.dispatch('requestLoadedArticleImage', image)
}
app.config.globalProperties.$imageLoading = (image, forceEager = false) => {
    return forceEager || store.state.loadedArticleImages?.[image] ? 'eager' : 'lazy'
}
app.config.globalProperties.$imageFetchPriority = (image, forceHigh = false) => {
    return forceHigh || store.state.loadedArticleImages?.[image] ? 'high' : 'auto'
}

// Configurer Laravel Echo
window.Echo = new Echo({
    broadcaster: 'pusher',
    key: "abcdef123456",
    wsHost: import.meta.env.VITE_APP_HOST,
    wsPort: import.meta.env.VITE_APP_PORT_WEBSOCKET,
    cluster: "",
    forceTLS: import.meta.env.VITE_APP_ENV === 'production',
    encrypted: import.meta.env.VITE_APP_ENV === 'production',
    disableStats: true,
    enabledTransports: ['ws', 'wss'],
    authEndpoint: store.state.api + 'broadcasting/auth',
    auth: {
        headers: {
            Authorization: `Bearer ${localStorage.getItem('jwtToken')}`,
        }
    },
    logToConsole: import.meta.env.VITE_APP_ENV !== 'production',
})

app.config.globalProperties.$formatDoualaDate = (dateString) => {
  if (!dateString) return ''
  const langue = localStorage.getItem('langue') || 'fr-FR'
  const normalizedDate = String(dateString).trim()
  const hasTimezone = /(?:Z|[+-]\d{2}:?\d{2})$/i.test(normalizedDate)
  const date = new Date(
    hasTimezone
      ? normalizedDate
      : normalizedDate.replace(' ', 'T') + '+01:00'
  )
  return new Intl.DateTimeFormat(langue, {
    timeZone: 'Africa/Douala',
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit'
  }).format(date)
}

app.config.globalProperties.$compressImage = (file, maxWidth = 1280, quality = 0.7) => {
    return new Promise((resolve, reject) => {
        const img = new Image();

        img.onload = () => {
        const canvas = document.createElement('canvas');

        // Calcul ratio
        const scale = Math.min(1, maxWidth / img.width);
        canvas.width = img.width * scale;
        canvas.height = img.height * scale;

        const ctx = canvas.getContext('2d');
        ctx.drawImage(img, 0, 0, canvas.width, canvas.height);

        // Conversion en JPEG compressé
        canvas.toBlob(
            (blob) => {
            if (!blob) {
                reject(new Error("Compression échouée"));
                return;
            }

            const compressedFile = new File(
                [blob],
                file.name.replace(/\.\w+$/, ".jpg"),
                { type: "image/jpeg" }
            );

            resolve(compressedFile);
            },
            "image/jpeg",
            quality // 0.6 - 0.8 recommandé
        );
        };

        img.onerror = reject;
        img.src = URL.createObjectURL(file);
    });
}

// Ajouter les plugins et monter l'application
pwaForceUpdate()

let pwaInstallationRegistrationStarted = false

const tryRegisterPwaInstallation = () => {
    if (pwaInstallationRegistrationStarted || !localStorage.getItem('jwtToken')) {
        return
    }

    pwaInstallationRegistrationStarted = true
    registerPwaInstallation(store.state.api, 'melcaisse')
        .catch(() => {
            pwaInstallationRegistrationStarted = false
        })
}

setTimeout(tryRegisterPwaInstallation, 3500)
router.afterEach(() => {
    setTimeout(tryRegisterPwaInstallation, 1500)
})

registerSmartImageLoading(app, store)

app.use(Vue3Marquee)
   .use(i18n)
   .use(emitter)
   .use(moment)
   .use(router)
   .use(store)
   .use(VueAxios, axios)
   .mount('#app')
